module.exports = __webpack_public_path__ + "static/img/22.b4f761d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/22.png
// module id = vHEM
// module chunks = 0